<template>
  <div class="language-selector">
    <button 
      class="flag-button"
      :class="{ active: currentLanguage === 'en', inactive: currentLanguage !== 'en' }"
      @click="setLanguage('en')"
      :disabled="isTranslationLoading"
      title="English"
    >
      <img src="@/assets/flag_canada.png" alt="Canada Flag" class="flag-image" />
    </button>
    <button 
      class="flag-button"
      :class="{ active: currentLanguage === 'kr', inactive: currentLanguage !== 'kr' }"
      @click="setLanguage('kr')"
      :disabled="isTranslationLoading"
      title="한국어"
    >
      <img src="@/assets/flag_korea.png" alt="Korea Flag" class="flag-image" />
    </button>
  </div>
</template>

<script>
import translationMixin from '@/mixins/translationMixin';

export default {
  name: 'LanguageSelector',
  mixins: [translationMixin],
  methods: {
    async setLanguage(language) {
      if (this.currentLanguage === language || this.isTranslationLoading) {
        return;
      }
      
      try {
        const success = await this.$setLanguage(language);
        if (success) {
          // Emit event to notify parent components of language change
          this.$emit('language-changed', language);
        }
      } catch (error) {
        console.error('Failed to change language:', error);
      }
    }
  }
};
</script>

<style scoped>
.language-selector {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.flag-button {
  background: none;
  border: none;
  padding: 0.25rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
}

.flag-button:hover {
  transform: scale(1.05);
}

.flag-button.active {
  transform: scale(1.1);
}

.flag-button.inactive {
  opacity: 0.5;
  filter: grayscale(70%) saturate(0.3);
}

.flag-button:disabled {
  cursor: not-allowed;
  opacity: 0.3;
}

.flag-button:disabled:hover {
  transform: none;
}

.flag-image {
  width: 32px;
  height: 24px;
  object-fit: cover;
  border-radius: 2px;
  transition: all 0.3s ease;
}

/* Mobile styles */
@media (max-width: 768px) {
  .language-selector {
    gap: 0.25rem;
  }
  
  .flag-button {
    min-width: 35px;
    height: 35px;
    padding: 0.2rem;
  }

  .flag-image {
    width: 28px;
    height: 21px;
  }
}
</style>